import { Grid2 } from "@mui/material";
import { useWatch } from "react-hook-form";

const evaluateCondition = (val1, condition, val2) => {
  switch (condition) {
    case "==":
      return val1 == val2;
    case "!=":
      return val1 != val2;
    case ">":
      return val1 > val2;
    case "<":
      return val1 < val2;
    case ">=":
      return val1 >= val2;
    case "<=":
      return val1 <= val2;
    default:
      return false;
  }
};

const FieldRenderer = ({
  field,
  index,
  control,
  register,
  errors,
  componentMap,
  currentFields,
}) => {
  const allValues = useWatch({ control });

  const Component = componentMap[field.type];
  if (!Component) return null;

  const uniqueName = `${field.name}_${field?.answer_id}`;
  const isHtmlLabel =
    typeof field.label === "string" && /<\/?[a-z][\s\S]*>/i.test(field.label);

  let shouldRender = true;
  let shouldDisable = false;

  if (field.forceDisabled) {
    shouldDisable = true;
  }

  if (
    field.dependsOn &&
    field.hasCondition &&
    field.hasValue &&
    field.doRule !== "true"
  ) {
    const dependsOnField = currentFields?.find((f) => f.id === field.dependsOn);

    const dependsOnKey = dependsOnField
      ? `${dependsOnField.name}_${dependsOnField.answer_id}`
      : null;

    const dependsOnValue = dependsOnKey ? allValues?.[dependsOnKey] : null;

    const conditionMet = evaluateCondition(
      dependsOnValue,
      field.hasCondition,
      field.hasValue
    );

    if (conditionMet) {
      if (field.doRule === "false") shouldRender = false;
      if (field.doRule === "-1") shouldDisable = true;
    }
  }

  if (!shouldRender) return null;

  return (
    <Grid2
      key={index}
      size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}
      sx={{ display: "flex", flexDirection: "column", width: "100%", mb: 3 }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "16px",
          justifyContent: "center",
        }}
      >
        {/* Label */}
        <div
          style={{
            flex: "0 0 200px",
            textAlign: "right",
            wordWrap: "break-word",
            paddingTop: "8px",
          }}
        >
          {isHtmlLabel ? (
            <>
              <span
                dangerouslySetInnerHTML={{ __html: field.label }}
                style={{ display: "inline-block" }}
              />
              {field?.required && (
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              )}
            </>
          ) : (
            <>
              {field.label}
              {field?.required && (
                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
              )}
            </>
          )}
        </div>

        {/* Component + Error */}
        <div
          style={{
            flex: 1,
            maxWidth: "400px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Component
            label={field.label}
            name={uniqueName}
            props={field.props}
            register={register}
            control={control}
            options={field?.options}
            isRequired={field?.required}
            disabled={shouldDisable}
            specialProps={field?.specialProps}
          />

          {/* Error Message */}
          {field.type === "AgeRange" ? (
            <div
              style={{
                display: "flex",
                justifyContent:
                  errors[uniqueName]?.start && errors[uniqueName]?.end
                    ? "space-between"
                    : errors[uniqueName]?.end
                    ? "flex-end"
                    : "flex-start",
                gap: "10px",
                marginTop: "4px",
              }}
            >
              {errors[uniqueName]?.start && (
                <div style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors[uniqueName]?.start?.message}
                </div>
              )}
              {errors[uniqueName]?.end && (
                <div style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors[uniqueName]?.end?.message}
                </div>
              )}
            </div>
          ) : (
            errors[uniqueName] && (
              <div
                style={{
                  color: "red",
                  fontSize: "0.8rem",
                  marginTop: "4px",
                }}
              >
                {errors[uniqueName]?.message}
              </div>
            )
          )}
        </div>
      </div>
    </Grid2>
  );
};

export default FieldRenderer;
